// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__3_HPz","list":"BalanceDue_list__2yXpF","listRow":"BalanceDue_listRow__3AHkL","total":"BalanceDue_total__w83_t"};